import { useEffect, useState } from 'react';
import { Link, useParams } from 'react-router-dom';
import { EyeIcon } from '@/ui/icons';
import { api } from '@/utils/api';

type Post = {
  id: string;
  title: string;
  slug: string;
  excerpt?: string;
  coverImageUrl?: string;
  publishedAt?: string;
  viewCount?: number;
};

export function CategoryPage() {
  const { slug } = useParams();
  const [name, setName] = useState('');
  const [posts, setPosts] = useState<Post[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let ignore = false;
    (async () => {
      try {
        const res = await api.get(`/api/public/category/${slug}`);
        if (!ignore) {
          setName(res.category?.name ?? 'Kategori');
          setPosts(res.posts ?? []);
        }
      } finally {
        if (!ignore) setLoading(false);
      }
    })();
    return () => {
      ignore = true;
    };
  }, [slug]);

  return (
    <div>
      <h1 className="text-2xl md:text-3xl font-serif font-bold mb-6">{name}</h1>
      {loading && <div>Yükleniyor…</div>}
      {!loading && posts.length === 0 && <div>Bu kategoride içerik yok.</div>}
      <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
        {posts.map((post) => (
          <Link to={`/yazi/${post.slug}`} key={post.id} className="card overflow-hidden hover:shadow-md transition">
            {post.coverImageUrl && (
              <img src={post.coverImageUrl} alt={post.title} className="h-44 w-full object-cover" />
            )}
            <div className="p-4">
              <h2 className="text-lg font-semibold mb-1">{post.title}</h2>
              {post.excerpt && <p className="text-sm text-gray-600 line-clamp-3">{post.excerpt}</p>}
              <div className="mt-2 text-sm text-gray-600 inline-flex items-center gap-1">
                <EyeIcon /> {post.viewCount ?? 0}
              </div>
            </div>
          </Link>
        ))}
      </div>
    </div>
  );
}


